import React from 'react';
import { Modal } from 'react-bootstrap';

/**
 * Enveloppe modal premium pour l'espace réception.
 * Header (titre + sous-titre), corps scrollable, pied sticky.
 */
export default function ReceptionModalShell({
  show,
  onHide,
  title,
  subtitle,
  size = 'lg',
  children,
  footer,
  dialogClassName = '',
  bodyClassName = '',
  disableClose = false,
  scrollable = true,
  centered = true,
  'aria-labelledby': ariaLabelledBy = 'recv-modal-title'
}) {
  return (
    <Modal
      show={show}
      onHide={disableClose ? undefined : onHide}
      centered={centered}
      scrollable={scrollable}
      size={size}
      backdrop="static"
      dialogClassName={`recv-modal-dialog ${dialogClassName}`.trim()}
      contentClassName="recv-modal"
      backdropClassName="recv-modal-backdrop"
      aria-labelledby={ariaLabelledBy}
    >
      <Modal.Header className="recv-modal__header" closeButton={!disableClose}>
        <div className="recv-modal__header-text">
          <Modal.Title id="recv-modal-title" className="recv-modal__title">
            {title}
          </Modal.Title>
          {subtitle && <p className="recv-modal__subtitle mb-0">{subtitle}</p>}
        </div>
      </Modal.Header>
      <Modal.Body className={`recv-modal__body ${bodyClassName}`.trim()}>{children}</Modal.Body>
      {footer != null && <Modal.Footer className="recv-modal__footer">{footer}</Modal.Footer>}
    </Modal>
  );
}

export function ReceptionModalSection({ title, description, children, className = '' }) {
  return (
    <section className={`recv-modal-section ${className}`.trim()}>
      {title && <h3 className="recv-modal-section__title">{title}</h3>}
      {description && <p className="recv-modal-section__desc">{description}</p>}
      {children}
    </section>
  );
}

export function ReceptionFormField({
  label,
  htmlFor,
  required = false,
  hint,
  error,
  children,
  className = ''
}) {
  return (
    <div className={`recv-form-field ${className}`.trim()}>
      {label && (
        <label htmlFor={htmlFor} className="recv-form-field__label">
          {label}
          {required && (
            <span className="recv-form-field__required" aria-hidden>
              {' '}
              *
            </span>
          )}
        </label>
      )}
      {children}
      {hint && !error && <div className="recv-form-field__hint">{hint}</div>}
      {error && (
        <div className="recv-form-field__error" role="alert">
          {error}
        </div>
      )}
    </div>
  );
}
